import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthenticationService } from '../service/authentication.service';
import { UserSessionService } from '../_client-service/user-session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private userSessionSrv: UserSessionService
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.authenticationService.logged().pipe(map(
            result => {
                return true;
            },
            error => {
                // this.router.navigate(['']);
                this.userSessionSrv.setUser(null);
                return false;
            }
        ));
    }

}
